export const corresponding = {
  'Cape Verde': 'Cabo Verde',
  Myanmar: 'Burma',
  'Republic of the Congo': 'Congo (Brazzaville)',
  'Democratic Republic of the Congo': 'Congo (Kinshasa)',
  'Ivory Coast': "Cote d'Ivoire",
  Swaziland: 'Eswatini',
  Vatican: 'Holy See',
  'South Korea': 'Korea, South',
  Macedonia: 'North Macedonia',
  Taiwan: 'Taiwan*',
  'United States': 'US',
  'Palestinian Territory': 'West Bank and Gaza',
};

export const leftovers = [
  'Diamond Princess',
  'MS Zaandam',
  'Timor-Leste',
];

export const continentsList = [
  {
    code: 'AF',
    name: 'Africa',
  },
  {
    code: 'AS',
    name: 'Asia',
  },
  {
    code: 'EU',
    name: 'Europe',
  },
  {
    code: 'NA',
    name: 'North America',
  },
  {
    code: 'OC',
    name: 'Oceania',
  },
  {
    code: 'SA',
    name: 'South America',
  },
];

export const pop = {
  'AD/': 84000,
  'AE/': 4975593,
  'AF/': 29121286,
  'AG/': 86754,
  'AL/': 2986952,
  'AM/': 2968000,
  'AO/': 13068161,
  'AR/': 41343201,
  'AT/': 8205000,
  'AU/': 21515754,
  'AZ/': 8303512,
  'BA/': 4590000,
  'BB/': 285653,
  'BD/': 156118464,
  'BE/': 10403000,
  'BF/': 16241811,
  'BG/': 7148785,
  'BH/': 738004,
  'BI/': 9863117,
  'BJ/': 9056010,
  'BN/': 395027,
  'BO/': 9947418,
  'BR/': 201103330,
  'BS/': 301790,
  'BT/': 699847,
  'BW/': 2029307,
  'BY/': 9685000,
  'BZ/': 314522,
  'CA/': 33679000,
  'CD/': 70916439,
  'CF/': 4844927,
  'CG/': 3039126,
  'CH/': 7581000,
  'CI/': 21058798,
  'CL/': 16746491,
  'CM/': 19294149,
  'CN/': 1330044000,
  'CO/': 47790000,
  'CR/': 4516220,
  'CU/': 11423000,
  'CV/': 508659,
  'CY/': 1102677,
  'CZ/': 10476000,
  'DE/': 81802257,
  'DJ/': 740528,
  'DK/': 5484000,
  'DM/': 72813,
  'DO/': 9823821,
  'DZ/': 34586184,
  'EC/': 14790608,
  'EE/': 1291170,
  'EG/': 80471869,
  'EH/': 273008,
  'ER/': 5792984,
  'ES/': 46505963,
  'ET/': 88013491,
  'FI/': 5244000,
  'FJ/': 875983,
  'FM/': 107708,
  'FR/': 64768389,
  'GA/': 1545255,
  'GB/': 62348447,
  'GD/': 107818,
  'GE/': 4630000,
  'GG/': 65228,
  'GH/': 24339838,
  'GM/': 1593256,
  'GN/': 10324025,
  'GQ/': 1014999,
  'GR/': 11000000,
  'GT/': 13550440,
  'GW/': 1565126,
  'GY/': 748486,
  'HN/': 7989415,
  'HR/': 4284889,
  'HT/': 9648924,
  'HU/': 9982000,
  'ID/': 242968342,
  'IE/': 4622917,
  'IL/': 7353985,
  'IN/': 1173108018,
  'IQ/': 29671605,
  'IR/': 76923300,
  'IS/': 308910,
  'IT/': 60340328,
  'JE/': 90812,
  'JM/': 2847232,
  'JO/': 6407085,
  'JP/': 127288000,
  'KE/': 40046566,
  'KG/': 5776500,
  'KH/': 14453680,
  'KI/': 92533,
  'KM/': 773407,
  'KN/': 51134,
  'KR/': 48422644,
  'KW/': 2789132,
  'KZ/': 15340000,
  'LA/': 6368162,
  'LB/': 4125247,
  'LC/': 160922,
  'LI/': 35000,
  'LK/': 21513990,
  'LR/': 3685076,
  'LS/': 1919552,
  'LT/': 2944459,
  'LU/': 497538,
  'LV/': 2217969,
  'LY/': 6461454,
  'MA/': 33848242,
  'MC/': 32965,
  'MD/': 4324000,
  'ME/': 666730,
  'MG/': 21281844,
  'MK/': 2062294,
  'ML/': 13796354,
  'MM/': 53414374,
  'MN/': 3086918,
  'MR/': 3205060,
  'MT/': 403000,
  'MU/': 1294104,
  'MV/': 395650,
  'MW/': 15447500,
  'MX/': 112468855,
  'MY/': 28274729,
  'MZ/': 22061451,
  'NA/': 2128471,
  'NE/': 15878271,
  'NG/': 154000000,
  'NI/': 5995928,
  'NL/': 16645000,
  'NO/': 5009150,
  'NP/': 28951852,
  'NZ/': 4252277,
  'OM/': 2967717,
  'PA/': 3410676,
  'PE/': 29907003,
  'PG/': 6064515,
  'PH/': 99900177,
  'PK/': 184404791,
  'PL/': 38500000,
  'PS/': 3800000,
  'PT/': 10676000,
  'PY/': 6375830,
  'QA/': 840926,
  'RO/': 21959278,
  'RS/': 7344847,
  'RU/': 140702000,
  'RW/': 11055976,
  'SA/': 25731776,
  'SC/': 88340,
  'SD/': 35000000,
  'SE/': 9828655,
  'SG/': 4701069,
  'SI/': 2007000,
  'SK/': 5455000,
  'SL/': 5245695,
  'SM/': 31477,
  'SN/': 12323252,
  'SO/': 10112453,
  'SR/': 492829,
  'SS/': 8260490,
  'ST/': 175808,
  'SV/': 6052064,
  'SY/': 22198110,
  'SZ/': 1354051,
  'TD/': 10543464,
  'TG/': 6587239,
  'TH/': 67089500,
  'TJ/': 7487489,
  'TL/': 1154625,
  'TN/': 10589025,
  'TR/': 77804122,
  'TT/': 1228691,
  'TW/': 22894384,
  'TZ/': 41892895,
  'UA/': 45415596,
  'UG/': 33398682,
  'US/': 310232863,
  'UY/': 3477000,
  'UZ/': 27865738,
  'VA/': 921,
  'VC/': 104217,
  'VE/': 27223228,
  'VN/': 89571130,
  'VU/': 221552,
  'WS/': 192001,
  'XK/': 1800000,
  'YE/': 23495361,
  'ZA/': 49000000,
  'ZM/': 13460305,
  'ZW/': 13061000,
};
